import addMount from "../../core/addMount";
import SearchResult from "./search-result.entry";

addMount({ appName: "search-result", app: SearchResult });
